// import ContentSitemapPagesEndpoint from "./endpoints/content/ContentSitemapPages.endpoint";
// import ContentMenuItemsEndpoint from "./endpoints/content/ContentMenuItems.endpoint";
import AuthEndpoint from "./endpoints/auth/Auth.endpoint";
import { KyInstance } from "ky/distribution/types/ky";
import ky, { Options } from 'ky';
import ApiClientInterface from "@/projectRoot/api-client/interfaces/ApiClient.interface";
import ContentMenuItemsEndpoint from "./endpoints/content/ContentMenuItems.endpoint";
import ProductsEndpoint from "./endpoints/products/Products.endpoint";
import ContentSitemapPagesEndpoint from "./endpoints/content/ContentSitemapPages.endpoint";
import ProductEntitiesEndpoint from "./endpoints/products/ProductEntities.endpoint";
import NewsEndpoint from "./endpoints/news/News.endpoint";
import ContentNotificationsEndpoint from "./endpoints/content/ContentNotifications.endpoint";
import MarketingNewsletterEndpoint from "./endpoints/marketing/MarketingNewsletter.endpoint";
import WebshopShoppingCartEndpoint from "./endpoints/webshop/WebshopShoppingCart.endpoint";
import ProfileEndpoint from "./endpoints/profile/Profile.endpoint";
import WebshopCheckoutEndpoint from "./endpoints/webshop/WebshopCheckout.endpoint";
import CartItemEntitiesEndpoint from "./endpoints/webshop/CartItemEntities.endpoint";
import CompanySettingsEndpoint from "./endpoints/company/CompanySettings.endpoint";
import CustomersEndpoint from "./endpoints/customers/Customers.endpoint";
import WebshopOrderEndpoint from "./endpoints/webshop/WebshopOrder.endpoint";

export default class KyApiClient implements ApiClientInterface {

  public static singleton: KyApiClient | null = null;
  private _httpClient: KyInstance;
  private cache: RequestCache;

  private constructor(options: Options, cache: RequestCache = "no-store") {
    // super();
    this._httpClient = ky.extend(options);
    this.cache = cache;
  }

  public static createApiClient(language?: string, options?: Options): KyApiClient {
    // console.log('language: ', language);

    let baseOptions = options ?? {
      prefixUrl: process.env.API_BASE_URL ?? 'http://nginx:1200/api',
      headers: {
        'x-service-token': process.env.X_SERVICE_TOKEN,
        'accept-language': language
      }
    }

    if (!KyApiClient.singleton) {
      KyApiClient.singleton = new KyApiClient(baseOptions);
      return KyApiClient.singleton;
    }

    KyApiClient.singleton._httpClient = ky.extend(baseOptions);
    return KyApiClient.singleton;
  }


  get httpClient(): KyInstance {
    if (!this._httpClient) {
      throw new Error('Ky http client is not initialized');
    }
    return this._httpClient;
  }

  set httpClient(kyInstance: KyInstance) {
    this._httpClient = kyInstance;
  }

  // API SERVICES
  // AUTH
  public auth(): AuthEndpoint {
    return new AuthEndpoint(this._httpClient, "no-store");
  }
  // PROFILE
  public profile(): ProfileEndpoint {
    return new ProfileEndpoint(this._httpClient, "no-store");
  }

  public customers(): CustomersEndpoint {
    return new CustomersEndpoint(this._httpClient, "no-store");
  }

  // SERVICES
  // public servicesIdentityToken(): ServicesIdentityTokenEndpoint {
  //     return new ServicesIdentityTokenEndpoint(this._httpClient, "no-store");
  // }

  // public servicesCustomer(): ServicesCustomersEndpoint {
  //     return new ServicesCustomersEndpoint(this._httpClient, "no-store");
  // }

  // CONTENT
  /**
  * @returns ContentMenuItemsEndpoint
  */
  public contentMenusItems(): ContentMenuItemsEndpoint {
    return new ContentMenuItemsEndpoint(this._httpClient, this.cache);
  };

  /**
  * @returns ContentSitemapPagesEndpoint
  */
  public contentSitemapPages(): ContentSitemapPagesEndpoint {
    return new ContentSitemapPagesEndpoint(this._httpClient, this.cache);
  };

  /**
  * @returns ContentNotifications Endpoint
  */
  public contentNotifications(): ContentNotificationsEndpoint {
    return new ContentNotificationsEndpoint(this._httpClient, this.cache);
  };

  public companySettings(): CompanySettingsEndpoint {
    return new CompanySettingsEndpoint(this._httpClient, this.cache);  
  }

  public products(): ProductsEndpoint {
    return new ProductsEndpoint(this._httpClient, this.cache);
  }

  public productEntities(): ProductEntitiesEndpoint {
    return new ProductEntitiesEndpoint(this._httpClient, this.cache);
  }

  public news(): NewsEndpoint {
    return new NewsEndpoint(this._httpClient, this.cache);
  }

  public marketingNewsletter(): MarketingNewsletterEndpoint {
    return new MarketingNewsletterEndpoint(this._httpClient, this.cache);
  }

  public cartItemEntities(): CartItemEntitiesEndpoint {
    return new CartItemEntitiesEndpoint(this._httpClient, this.cache);
  }

  public webshopShoppingCart(): WebshopShoppingCartEndpoint {
    return new WebshopShoppingCartEndpoint(this._httpClient, this.cache);
  }

  public webshopCheckout(): WebshopCheckoutEndpoint {
    return new WebshopCheckoutEndpoint(this._httpClient, this.cache);
  }

  public webshopOrder(): WebshopOrderEndpoint {
    return new WebshopOrderEndpoint(this._httpClient, this.cache);
  }

}